import { Component, ErrorInfo, ReactNode } from 'react';

interface IErrorBoundaryProps {
    children: ReactNode;
}

interface IErrorBoundaryState {
    hasError: boolean;
}

// Catches render-time errors anywhere below it so a single failing component
// can't take down the whole admin panel. Network/async errors are handled
// separately (toasts in useHttpRequest) and don't reach here.
class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): IErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error('Unhandled UI error:', error, errorInfo);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: '100vh', padding: '2rem' }}>
                    <h2 className="mb-1">Something went wrong</h2>
                    <p className="text-muted mb-2">An unexpected error occurred while rendering this page.</p>
                    <button className="btn btn-primary" onClick={this.handleReload}>
                        Reload page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
